import { workspaceConstants } from "../_constants";


export function workspaceProfiles(state = {}, action) {
  switch (action.type) {
    case workspaceConstants.GET_WORKSPACE_DETAILS_REQUEST:
      return {
        loading: true,
      };
    case workspaceConstants.GET_WORKSPACE_DETAILS_SUCCESS:
      return {
        item: action.workspace,
      };
    case workspaceConstants.GET_WORKSPACE_DETAILS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function activeWorkspaces(state = {}, action) {
  switch (action.type) {
    case workspaceConstants.GET_ALL_ACTIVE_WORKSPACE_REQUEST:
      return {
        loading: true,
      };
    case workspaceConstants.GET_ALL_ACTIVE_WORKSPACE_SUCCESS:
      return {
        item: action.workspace,
      };
    case workspaceConstants.GET_ALL_ACTIVE_WORKSPACE_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function addWorkspace(state = {}, action) {
  switch (action.type) {
    case workspaceConstants.CREATE_WORKSPACE_DETAILS_REQUEST:
      return {
        loading: true,
      };
    case workspaceConstants.CREATE_WORKSPACE_DETAILS_SUCCESS:
      return {
        item: action.data
      };
    case workspaceConstants.CREATE_WORKSPACE_DETAILS_FAILURE:
      return {};
    default:
      return state;
  }
}

export function editWorkspace(state = {}, action) {
  switch (action.type) {
    case workspaceConstants.UPDATE_WORKSPACE_DETAILS_REQUEST:
      return {
        loading: true,
      };
    case workspaceConstants.UPDATE_WORKSPACE_DETAILS_SUCCESS:
      return action.data;
    case workspaceConstants.UPDATE_WORKSPACE_DETAILS_FAILURE:
      return action.error;
    default:
      return state;
  }
}

export function deleteWorkspace(state = {}, action) {
  switch (action.type) {
    case workspaceConstants.DELETE_WORKSPACE_DETAILS_REQUEST:
      return {
        loading: true,
      };
    case workspaceConstants.DELETE_WORKSPACE_DETAILS_SUCCESS:
      return {
        item: action.data
      };
    case workspaceConstants.DELETE_WORKSPACE_DETAILS_FAILURE:
      return {};
    default:
      return state;
  }
}
export function workspaceProps(state = {}, action) {
  switch (action.type) {
    case workspaceConstants.GET_WORKSPACE_PROPS_REQUEST:
      return {
        loading: true,
      };
    case workspaceConstants.GET_WORKSPACE_PROPS_SUCCESS:
      return {
        items: action.data,
      };
    case workspaceConstants.GET_WORKSPACE_PROPS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}